import React from 'react';
import { Link } from 'react-router-dom';
import ImageHolder from 'views/components/ImageHolder';
import { getImageUrl } from 'utils/imageUtils';
import { Image } from 'models/Medium';

// 투명 이미지
const IMG_BOX =
  'data:image/png;base64,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';

interface Props {
  images: Image[];
  postPath: string;
  tiaraClickHandler?: Function;
}
const ImageFeedView: React.FC<Props> = ({
  images,
  postPath,
  tiaraClickHandler
}) => {
  const firstImage = images[0];
  const isSquare = firstImage.width === firstImage.height;
  const isHorizontal = firstImage.width > firstImage.height;

  if (images.length === 1) {
    return (
      <div className="post_card">
        <div className="card_default">
          <div className="wrap_thumb">
            <Link
              to={postPath}
              className="link_post"
              onClick={() => {
                if (tiaraClickHandler) {
                  tiaraClickHandler(1);
                }
              }}
            >
              <ImageHolder image={firstImage} />
            </Link>
          </div>
        </div>
      </div>
    );
  } else {
    const styleNumber = images.length > 4 ? 4 : images.length;
    const viewStyle = () => {
      if (isSquare) {
        return images.length >= 4
          ? `card_square`
          : `card_box${styleNumber}_rect`;
      } else if (!isHorizontal) {
        return 'card_vertical';
      }
      return '';
    };
    return (
      <div className={`post_card card_box card_box${styleNumber}`}>
        <div className={`card_default ${viewStyle()}`}>
          <img src={IMG_BOX} className="thumb_box" alt="" />
          <ul className="list_thumb">
            {images.map((image, index) => {
              if (index >= 4) {
                return null;
              }
              return (
                <li key={index}>
                  <Link
                    to={postPath}
                    className="link_thumb"
                    onClick={() => {
                      if (tiaraClickHandler) {
                        tiaraClickHandler(index + 1);
                      }
                    }}
                  >
                    <div
                      className="wrap_thumb"
                      style={{
                        backgroundImage: `url("${getImageUrl(image.largeUrl)}")`
                      }}
                    >
                      <span className="screen_out">이미지 보기</span>
                      <span className="frame_g" />
                      {index === 3 && images.length > 4 ? (
                        <span className="txt_all">
                          {`+${images.length - 4}`}
                          <span className="screen_out">개 더보기</span>
                        </span>
                      ) : (
                        ''
                      )}
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
};

export default ImageFeedView;
